export default () => {
	if (document.querySelector('.js-print-schedule')) {
		const printBlock = (dom) => {
			document.querySelectorAll('.carousel__item:not(.carousel__item--active)').forEach((el) => el.remove())

			document.querySelector('.carousel__list').style.transform = 'translate3d(0px, 0px, 0px)'

			const details = document.querySelector(dom).innerHTML

			document.querySelector('.wrapper').innerHTML = document.body.innerHTML = details

			window.print()
			window.location.reload()
		}

		document.querySelector('.js-print-schedule').addEventListener('click', function () {
			printBlock('.schedule-detail')
		})
	}
}
